/*
Akhila 04/13/2023 2699762545 created warning popup messages
Prakash 09/05/2023 2699762545 fixedbutton spacing issue letter-batches .

*/
import React from 'react';
import {Button, Typography} from '@material-ui/core';
import reusableInputStyles from '../../../components/InputStyles';
function ExecuteWarningPopup({handleValidationClose, warningError}) {
  const classes = reusableInputStyles();
  return (
    <div>
      <div className={classes.dialoguecardStyles}>
        <div className="text-center my-3">
          <Typography variant="h4"> {warningError}</Typography>
        </div>
        <div className="d-flex justify-content-center new-standard-textfields">
          <Button
            type="button"
            variant="outlined"
            className={`ml-1 reset-btn`}
            onClick={() => {
              handleValidationClose();
            }}
          >
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}
export default ExecuteWarningPopup;
